/**
 * @author MCSonka
 * @description Provides whimsical loading texts for the Multi-Media Wizard.
 * @module MultiMediaWizard/utils/LoadingTexts
 */

const loadingTexts = [
  'Gathering magical ingredients...',
  'Polishing the crystal ball...',
  'Consulting the Great Archive...',
  'Sharpening the quill...',
  'Deciphering the elder runes...',
  'Feeding the owl treats...',
  'Organizing the component pouch...',
  'Sorting the ritual candles...',
  'Harvesting glow-moss...',
  'Charting the astral planes...',
  'Mapping the dungeon floors...',
  'Lighting the torches...',
  'Tuning the resonant frequencies...',
  'Scrying for connection errors...',
  'Aligning the constellations...',
  'Entering the dungeon...',
  'Goblins are carefully rolling the gryphon eggs...',
  'Hiring more minions to turn the giant crank...',
  'Greasing the drawbridge chains with troll fat...',
  'Convincing the gargoyles to hold the layout steady...',
  'Waking up the sleeping giant for the heavy lifting...',
  'Stoking the forge fires with dragon-breath...',
  'Loading the catapults with data packets...',
  'Bribing a mimic with a shiny new padlock...',
  'Checking the goblin-built scaffolding (fingers crossed)...',
  'Sharpening the rusty broadswords...',
  "Sorting the parchment by 'Most Ancient'...",
  'Sweeping the owlery floor...',
  'Checking the moving staircases for shortcuts...',
  'Wrangling an escaped textbook on monster care...',
  'Extracting the memory into a glass vial...',
  'Waiting for the portrait to finish its story...',
  'Asking the Sorting Hat for its professional opinion...',
  'Transfiguring the bugs into buttons...',
  'Feeding the three-headed dog a snack...',
];
const submittingTexts = [
  'Aligning pixels...',
  'Buffering awesomeness...',
  'Zug zug...',
  'Casting summoning spell...',
  'Charging the mana core...',
  'Aligning the stars...',
  'Inking the spellbook...',
  'Shaking the mojo bag...',
  'Polishing the staff...',
  'Distilling the mana crystals...',
  'Stabilizing the volatile reagents...',
  'Stirring the cauldron counter-clockwise...',
  'Chasing the escaped fire elementals...',
  'Cooling the molten glass...',
  'Bottling the essence of a thunderstorm...',
  'Waiting for the potion to turn blue...',
  'Filtering the swamp water...',
  'Calibrating the alembic...',
  'Opening a portal to the database...',
  'Bribing the local guards...',
  'Untangling the ley lines...',
  'Removing the hexes from the code...',
  'Strengthening the magical barrier...',
  'Recharging the wand of utility...',
  'Sweeping the workshop of magical residue...',
  'Banishing the bugs to the void...',
  'Sealing the scroll with heavy wax...',
  'Sending a carrier-owl to the North Tower...',
  "Casting 'Expecto Persistence'...",
  'Tossing the data into the Great Cauldron (for luck)...',
  'Negotiating terms with a very stubborn bridge-troll...',
  'Finalizing the unbreakable vow...',
  'Engraving the results into the stone tablet...',
  'Launching the dragon-fire signal...',
  'Chanting the final verse very loudly...',
  "Hiring a barbarian to smash the 'Submit' button...",
  "Applying another layer of 'Enchanted Duct-Tape'...",
];

/**
 * Returns a random text from the provided array of texts.
 * @param {string[]} texts - Array of loading texts.
 * @returns {string} A randomly selected loading text.
 */
const getRandomText = texts => {
  const index = Math.floor(Math.random() * texts.length); // nosonar

  return texts[index];
};

/**
 * Returns a random whimsical loading texs for the Multi-Media Wizard.
 * @param {string[]} texts - Array of loading texts.
 * @returns {string} A randomly selected loading text.
 */
const getLoadingText = (type = '') => {
  const categories = {
    loading: loadingTexts,
    submitting: submittingTexts,
  };

  return getRandomText(categories[type]) || 'Loading...';
};

export default getLoadingText;
